import React, { FC } from 'react';

import {
  Flex,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import GroupSelect from 'components/primitives/GroupSelect';
import SiteMultiSelect from 'components/primitives/SiteMultiSelect';

import {
  initialValues,
  validationSchema,
} from './AddCustomerContactModal.utils';

import { AddCustomerModalViewProps } from './AddCustomerContactModal.props';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const AddCustomerModalView: FC<AddCustomerModalViewProps> = (props) => {
  const { isOpen, onClose, onCreate, isCreating } = props;

  return (
    <Modal
      size="6xl"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader color="support.500" textAlign="center">
          Add customer contact
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" p={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onCreate}>
              {({ isValid, values }) => (
                <Form>
                  <Flex gap="20px">
                    <FormikInput
                      name="fname"
                      label="First Name(*)"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <FormikInput
                      name="lname"
                      label="Last Name(*)"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <FormikInput
                      name="role"
                      label="Role"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                  </Flex>
                  <Flex mt={6} gap="20px">
                    <FormikInput
                      type="email"
                      name="email"
                      label="Email (*)"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <FormikInput
                      type="number"
                      name="phone"
                      label="Phone"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                  </Flex>

                  <GroupSelect values={values.groups} />

                  <SiteMultiSelect values={values.sites} />

                  <Flex my={12} flexDirection="row" justifyContent="center">
                    <Button
                      variant="outline"
                      marginRight="10px"
                      isDisabled={isCreating}
                      w="134px"
                      onClick={onClose}>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      isLoading={isCreating}
                      isDisabled={!isValid}
                      w="134px">
                      Create
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddCustomerModalView;
